import {seoMetadata as seoMetadataJSON, seoMetadataForMerchandisedUrls} from "@next/utils"
import State from "../../../models/State"
import {selectSeoMetadataArgs} from "../selectSeoMetadataArgs"
import {replaceSeoMetadataPlaceholders} from "../replaceSeoMetadataPlaceholders"
import {getSeoTitleForMerchandisePath} from "../../getSeoTitleForMerchandiseUrl"
import {getSeoMetadataFromConfig} from "../getSeoMetadataFromConfig"
import {checkMultipleFacetsFromSameGroup} from "./checkMultipleFacetsFromSameGroup"
import {checkTaxonomyUrlAndRedirectOldUrls} from "./checkTaxonomyUrlAndRedirectOldUrls"
import {checkStructuredBrowsingAndCategoryFilter} from "./checkStructuredBrowsingAndCategoryFilter"
import {updateMerchandisedSeoMetaDataIndexing} from "./updateMerchandisedSeoMetaDataIndexing"
import {updateSeoMetaDataIndexing} from "./updateSeoMetaDataIndexing"

export function selectSeoMetadataForMerchandisedUrls(state: State) {
    const {market, realm} = selectSeoMetadataArgs(state)
    const title = getSeoTitleForMerchandisePath(state)
    const placeholders = {market, title, filters: "", searchTerm: ""}
    const replacedSeoMetaData = replaceSeoMetadataPlaceholders(seoMetadataForMerchandisedUrls[realm], placeholders)
    const seoIndexingUpdated = updateMerchandisedSeoMetaDataIndexing(state, replacedSeoMetaData)
    const seoMetadataWithStructuredBrowsing = checkStructuredBrowsingAndCategoryFilter(state, seoIndexingUpdated)
    return seoMetadataWithStructuredBrowsing
}

export function selectSeoMetadata(state: State) {
    if (state.request.isMerchandisedUrl) return selectSeoMetadataForMerchandisedUrls(state)
    const {realm, territory, searchTerm, market, searchType, filters, withFilters} = selectSeoMetadataArgs(state)
    const seoMetadata = getSeoMetadataFromConfig({realm, territory, searchType, withFilters, config: seoMetadataJSON})
    const seoMetaDataSaleIndexing = updateSeoMetaDataIndexing(state, seoMetadata)
    const seoMetadataWithMultipleFacetCheck = checkMultipleFacetsFromSameGroup(state, seoMetaDataSaleIndexing)
    const seoMetadataWithRedirectOldUrlsEnabled = checkTaxonomyUrlAndRedirectOldUrls(
        state,
        seoMetadataWithMultipleFacetCheck,
    )
    const placeholders = {searchTerm, filters, market}
    return replaceSeoMetadataPlaceholders(seoMetadataWithRedirectOldUrlsEnabled, placeholders)
}
